import Language from '~/boot/language-boot'

export default {
  key: "required",
  errorMessage: Language.get('validation.errors.required'),
  validate(value, args) {
    return Boolean(value)
  }
}